import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import PasswordReducer from './features/password/passwordSlice';
import PlayerReducer from './features/player/playerSlice';
import ChaptersReducer from './features/chapters/chaptersSlice';
import PreviewReducer from './features/preview/PreviewSlice';

export const store = configureStore({
  reducer: {
    password: PasswordReducer,
    playerConfig: PlayerReducer,
    chapters: ChaptersReducer,
    preview: PreviewReducer
  },
});

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
